import { AiOutlineRight } from 'react-icons/ai'
import { IOutputData } from '../../models/IOutputData'
import bwtIcon from '../../assets/BWT_LOGO.png'
import { GeneralTexts } from '../../language/Texts'

interface ShareProps {
    component: IOutputData
}

function CustomerPortal({ component }: ShareProps) {

    return (
        <a className="customer_portal share" rel='noopener noreferrer' href='https://www.bwt-aqua-portal.com' target='_blank'>
            <div className="share_text">
                <div className="share_title">{GeneralTexts.bwtCustomerPortal}</div>
                <div className="share_section_icon"><AiOutlineRight /></div>
            </div>
            <div className="analyse_icon_wrapper">
                <img src={bwtIcon} className='customer_logo' alt='BWT Logo' />
            </div>
        </a>
    )
}

export default CustomerPortal
